module.exports = __webpack_public_path__ + "static/media/french-fries.b674de67.svg";